<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="row mt-3 mb-4">
      <!-- Card 1 -->
      <div class="col-sm-4">
        <div
            class="alert alert-processing-activities-1 card-shadow radius-0-5"
            role="alert"
            v-b-tooltip.hover
            :title="$t('processes.processing_activities.first_card_description')">
          <!-- <span class="alert-processing-activities-1-icon">
            <font-awesome-icon icon="rocket"/>
          </span> -->
          <h5 class="mt-2 position-relative" style="z-index:1;">
            {{ $t('processes.processing_activities.first_card_title') }}
          </h5>
          <!-- <p style="min-height: 70px;z-index:1;" class="text-normal position-relative">
            {{ $t('processes.processing_activities.first_card_description') }}
          </p> -->
          <span v-if="isGranted(permissions.PROCESS_CREATE)" qid="create-p-button">
            <ProcessCreateModal
                @reloadContent="reloadProcesses()"
                buttonClass="btn-success"
            ></ProcessCreateModal>
          </span>
          <span v-if="getGuide('process_list_page')">
            <GuideButton
                :text="$t('processes.processing_activities.guide_button_label')"
                type="secondary"
                :guide="getGuide('process_list_page')"
                icon="video"
            ></GuideButton>
          </span>
        </div>
      </div>

      <div class="col-sm-4">
        <!-- Card 2 -->
        <div
            class="alert alert-processing-activities-2 card-shadow radius-0-5"
            role="alert"
            v-b-tooltip.hover
            :title="$t('processes.processing_activities.second_card_description')">
          <!-- <span class="alert-processing-activities-2-icon">
            <font-awesome-icon icon="calendar-alt"/>
          </span> -->
          <h5 class="mt-2 position-relative" style="z-index:1;">
            {{ $t('processes.processing_activities.second_card_title') }}
          </h5>
          <!-- <p style="min-height: 70px;z-index:1;" class="text-normal position-relative">
            {{ $t('processes.processing_activities.second_card_description') }}
          </p> -->
          <!-- <div class="mt-4 position-relative" style="z-index:1;"> -->
          <CreateProjectModal
              class=""
              v-if="getClient.projectModule"
              type="update"
              :types="types"
              scope="processingActivities"
          ></CreateProjectModal>
          <span
            class="btn btn-secondary cursor-pointer"
            v-if="getClient.projectModule"
            style="z-index:1;"
            @click="showProjectsModal()"
          >
            <font-awesome-icon icon="eye"/>
            {{ $t('processes.processing_activities.view_running_projects') }}
          </span>
          <a class="btn btn-secondary"
             href="https://www.complyon.com/project-module"
             qid="risk-read-more"
             target="_blank"
             v-else
          >
            <span class="side-nav--text">
              {{ $t('system.read_more') }}
            </span>
          </a>
          <!-- </div> -->
        </div>
      </div>

      <div class="col-sm-4">
        <!-- Card 3 -->
        <div
            class="alert alert-processing-activities-3 card-shadow radius-0-5"
            role="alert"
            v-b-tooltip.hover
            :title="$t('processes.processing_activities.third_card_description')">
          <!-- <span class="alert-processing-activities-3-icon">
            <font-awesome-icon icon="cloud-download-alt"/>
          </span> -->
          <h5 class="mt-2 position-relative" style="z-index:1;">
            {{ $t('processes.processing_activities.third_card_title') }}
          </h5>
          <!-- <p style="min-height: 70px;z-index:1;" class="text-normal position-relative">
            {{ $t('processes.processing_activities.third_card_description') }}
          </p> -->
          <!-- <div class="mt-4" style="z-index:1;"> -->
          <b-dropdown id="dropdown-left" variant="secondary" v-if="isGranted(permissions.MAINTENANCE_VIEW)">
            <b-dropdown-item>
              <span @click="openProcessModal()" qid="download_process_overview_report">
                {{ $t('processes.processing_activities.reports_button_process_overview') }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item>
              <span @click="openArticleModal()" qid="download_article_report">
                {{ $t('processes.processing_activities.reports_button_article_30') }}
              </span>
            </b-dropdown-item>
            <template slot="button-content">
              <font-awesome-icon icon="file-download"/>
              {{ $t('processes.processing_activities.reports_button') }}
            </template>
          </b-dropdown>
          <b-dropdown id="dropdown-left" variant="secondary" v-if="isGranted(permissions.MAINTENANCE_VIEW)">
            <b-dropdown-item @click="handleDownloadModal">
              {{ $t('processes.processing_activities.lists_button_processes') }}
            </b-dropdown-item>
            <b-dropdown-item @click="handleDownloadActivitiesModal">
              {{ $t('processes.processing_activities.lists_button_activities') }}
            </b-dropdown-item>
            <template slot="button-content">
              <font-awesome-icon icon="file-download"/>
              {{ $t('processes.processing_activities.lists_button') }}
            </template>
          </b-dropdown>
          <!-- </div> -->
        </div>
      </div>
    </div>

    <h4 qid="processes-page-title" class="mb-3">
      <button class="btn btn-secondary-dark float-right"
              @click="handleFilterButton(false)"
              qid="processes-filter-button"
      >
        <font-awesome-icon icon="filter"/>
      </button>

      <b-form-input
          type="text"
          v-model="filters.keywordValue"
          class="float-right mw-300 mr-3 search-bar"
          qid="search-a-input"
          v-on:input="debounceInput"
          :placeholder="$t('activities.search_placeholder')"
      ></b-form-input>

      {{ $t('processes.title') }}
    </h4>

    <div class="row" :class="{'table-with-filters': filterOpened}">
      <div class="col-sm-10 table-container">
        <div class="row tree-filter-row">
          <div class="col-sm-3 tree-filter-col">
            <div class="card filter-tree-view-container">
              <div class="card-body p-0 tree-filter-col">
                <ProcessSideFilter
                    v-if="SideFilterRenderComponent"
                    :selectedCategory="selectedCategory"
                    :updateCategoryList="updateCategoryList"
                    @updateSelected="updateSelectedFilter"
                ></ProcessSideFilter>
              </div>
            </div>
          </div>

          <div class="col-sm-9 tree-result-col">
            <ProcessTopBar
              :selectedCategory="selectedCategory"
              @forceSideFilterRenderComponent="forceSideFilterRenderComponent"
              @forceListUpdate="forceListUpdate"
            ></ProcessTopBar>

            <div class="tree-result-main">
              <table class="table table-responsive-md table-list-secondary">
                <thead>
                  <tr>
                    <th scope="col"
                        class="cursor-pointer"
                        @click="selectSort('name')"
                        qid="sort-p-name"
                    >
                      {{ $t('activities.table.name') }}
                      <span class="ml-2">
                        <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'name'"/>
                        <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'name'"/>
                        <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'name'"/>
                      </span>
                    </th>
                    <th scope="col" v-if="tableColumns.responsibles">
                      {{ $t('activities.table.owners') }}
                    </th>
                    <th scope="col" v-if="tableColumns.tags">
                      {{ $t('activities.table.tags') }}
                    </th>
                    <th scope="col" v-if="tableColumns.organizations">
                      {{ $t('activities.table.organizations') }}
                    </th>
                    <th scope="col" v-if="tableColumns.countries">
                      {{ $t('activities.table.countries') }}
                    </th>
                    <th scope="col" v-if="tableColumns.processGroup">
                      {{ $t('activities.table.process_groups') }}
                    </th>
                    <th scope="col"
                        class="cursor-pointer"
                        @click="selectSort('updated_at')"
                        qid="sort-s-name"
                        width="160"
                        v-if="tableColumns.lastModified">
                      {{ $t('system.last_updated') }}
                      <span class="ml-2">
                        <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'updated_at'"/>
                        <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'updated_at'"/>
                        <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'updated_at'"/>
                      </span>
                    </th>
                    <th width="140" class="text-right">
                      <b-nav-item-dropdown right extra-toggle-classes="no-dropdown-caret" class="guide-settings">
                        <!-- Using 'button-content' slot -->
                        <template slot="button-content">
                          <span class="float-right" style="list-style: none;">
                            <font-awesome-icon size="lg" icon="cog" class="text-muted"/>
                          </span>
                        </template>

                        <div class="pl-4 pr-4">
                          <b-form-checkbox
                            v-model="tableColumns.responsibles"
                            name="checkbox-disable"
                            :value="1"
                            :unchecked-value="0"
                          >
                            {{ $t('processes.table.owners') }}
                          </b-form-checkbox>
                          <br>
                          <b-form-checkbox
                            v-model="tableColumns.tags"
                            name="checkbox-disable"
                            :value="1"
                            :unchecked-value="0"
                          >
                            {{ $t('processes.table.tags') }}
                          </b-form-checkbox>
                          <br>
                          <b-form-checkbox
                            v-model="tableColumns.organizations"
                            name="checkbox-disable"
                            :value="1"
                            :unchecked-value="0"
                          >
                            {{ $t('activities.table.organizations') }}
                          </b-form-checkbox>
                          <br>
                          <b-form-checkbox
                            v-model="tableColumns.countries"
                            name="checkbox-disable"
                            :value="1"
                            :unchecked-value="0"
                          >
                            {{ $t('activities.table.countries') }}
                          </b-form-checkbox>
                          <br>
                          <b-form-checkbox
                            v-model="tableColumns.processGroup"
                            name="checkbox-disable"
                            :value="1"
                            :unchecked-value="0"
                          >
                            {{ $t('activities.table.process_groups') }}
                          </b-form-checkbox>
                          <br>
                          <b-form-checkbox
                            v-model="tableColumns.lastModified"
                            name="checkbox-disable"
                            :value="1"
                            :unchecked-value="0"
                          >
                            {{ $t('activities.table.last_modified') }}
                          </b-form-checkbox>
                          <br>
                        </div>
                        <hr>
                        <div class="pl-4 pr-4">
                          <small class="text-muted">
                            * {{ $t('system.global_table_expand_explainer_text') }}
                          </small>
                        </div>
                      </b-nav-item-dropdown>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(object, index) in tableItems" :key="'table-row-' + index" :id="'table-row-' + index">
                    <b-popover
                        :target="'table-row-' + index"
                        boundary="viewport"
                        triggers="hover"
                        placement="top"
                        :delay="{ show: 500, hide: 0 }"
                    >
                      <div v-if="object.description" class="mt-2">
                        <span class="text-bold">
                          {{ $t('maintenance.data_objects.table.description') }}:
                        </span>
                        <br>
                        {{ object.description | truncate(200)}}
                        <br>
                      </div>

                      <div v-if="object.organizations && object.organizations.length">
                        <span class="text-bold">
                          {{ $t('activities.table.organizations') }}:
                        </span>
                        <span v-for="organization in object.organizations">
                          <br>
                          <span qid="profile-photo">
                            <font-awesome-icon icon="sitemap"/>
                            {{ organization.name }}
                          </span>
                        </span>
                        <br>
                      </div>

                      <div v-if="object.countries_with_flag && object.countries_with_flag.length">
                        <span class="text-bold">
                          {{ $t('activities.table.countries') }}:
                        </span>
                        <span v-for="country in object.countries_with_flag">
                          <br>
                          <span qid="profile-photo">
                            <img v-bind:src="country.flag" height="13" class="align-baseline mr-1" /> <span>{{country.name}}</span>
                          </span>
                        </span>
                        <br>
                      </div>

                      <div v-if="object.tags_translated && object.tags_translated.length">
                        <span class="text-bold">
                          {{ $t('processes.table.tags') }}:
                        </span>
                        <br>
                        <span v-for="tag in object.tags_translated" qid="p-tags-list">
                          <span class="badge" :title="tag.name_translated">
                            <font-awesome-icon icon="tag"/>
                            {{ tag.name_translated }}
                          </span>
                        </span>
                        <br>
                      </div>

                      <div v-if="object.users && object.users.length">
                        <span class="text-bold">
                          {{ $t('processes.table.owners') }}:
                        </span>
                        <span v-for="user in object.users">
                          <br>
                          <span qid="profile-photo">
                            <Avatar :object="user" size="xs"></Avatar><span> {{ user.name }}</span>
                          </span>
                        </span>
                        <br>
                      </div>
                    </b-popover>

                    <td>
                      <router-link
                          :to="{ name: 'activities.view', params: { slug: object.slug }}"
                          qid="s-view-page-link"
                      >
                        {{ object.name }}
                      </router-link>
                    </td>
                    <td v-if="tableColumns.responsibles">
                      <span class="mr-1 text-normal" v-for="user in getReducedUsers(object.users)">
                        <span qid="profile-photo">
                          <Avatar :object="user" size="xs"></Avatar>
                        </span>
                      </span>
                      <span v-if="object.users.length > 3"
                            class="badge cursor-pointer"
                            @click="openUsersModal(object)"
                      >
                        <font-awesome-icon icon="users"/>
                        + {{ object.users.length - 3 }}
                      </span>
                    </td>
                    <td v-if="tableColumns.tags">
                      <span v-for="tag in getReducedTags(object.tags_translated)" qid="p-tags-list">
                        <span class="badge" :title="tag.name_translated">
                          <font-awesome-icon icon="tag"/>
                          {{ tag.name_translated | truncate(35) }}
                        </span>
                      </span>
                      <span v-if="object.tags_translated.length > 3"
                            class="badge cursor-pointer"
                            @click="openTagsModal(object)"
                      >
                        <font-awesome-icon icon="tags"/>
                        + {{ object.tags_translated.length - 3 }}
                      </span>
                    </td>
                    <td v-if="tableColumns.organizations">
                      <span class="mr-1" v-for="organization in getReducedOrganizations(object.organizations)" qid="p-organizations-list">
                        <span class="badge" :title="organization.name">
                          <font-awesome-icon icon="sitemap"/>
                          {{ organization.name | truncate(35) }}
                        </span>
                      </span>
                      <span v-if="object.organizations.length > 1"
                            class="badge cursor-pointer"
                            @click="openOrganizationsModal(object)"
                      >
                        + {{ object.organizations.length - 1 }}
                      </span>
                    </td>
                    <td v-if="tableColumns.countries">
                      <span v-if="object.countries_with_flag && object.countries_with_flag.length">
                        <span class="mr-1" v-for="country in getReducedCountries(object.countries_with_flag)" qid="p-countries-list">
                          <span class="badge">
                            <img v-bind:src="country.flag" height="13" class="align-baseline mr-1" /> <span>{{country.name}}</span>
                          </span>
                        </span>
                        <span v-if="object.countries_with_flag && object.countries_with_flag.length && object.countries_with_flag.length > 1"
                              class="badge cursor-pointer"
                              @click="openCountriesModal(object)"
                        >
                          + {{ object.countries_with_flag.length - 1 }}
                        </span>
                      </span>
                    </td>
                    <td v-if="tableColumns.processGroup">
                      <span class="mr-1" v-for="group in getReducedProcessGroups(object.process_groups)" qid="p-countries-list">
                        <span class="badge" style="font-weight: 400;" :title="group.name">
                          <font-awesome-icon icon="project-diagram"/>
                          {{ group.name | truncate(35) }}
                        </span>
                      </span>
                      <span v-if="object.process_groups.length > 1"
                            class="badge cursor-pointer"
                            @click="openProcessGroupsModal(object)"
                      >
                        + {{ object.process_groups.length - 1 }}
                      </span>
                    </td>
                    <td v-if="tableColumns.lastModified">
                      <span class="text-normal">
                        {{ object.updated_at | formatDate }}
                      </span>
                    </td>

                    <td align="right">
                      <ActivityEditForm
                          :object="object"
                          class="float-right"
                          style="margin-top: -3px;"
                          buttonClass="btn-xs"
                          @reloadContent="loadContent(currentPage)"
                          v-if="isGranted([permissions.ACTIVITY_EDIT, permissions.ACTIVITY_EDIT_OWN], object)"
                      ></ActivityEditForm>
                    </td>
                  </tr>

                  <tr v-if="!sLoading && !tableItems.length" qid="no-results-row" class="text-center">
                    <td colspan="10">
                      <h5 class="mt-3">
                        {{ $t('system.no_results') }}
                      </h5>
                    </td>
                  </tr>

                  <tr v-if="sLoading" qid="no-results-row-rr" class="text-center">
                    <td colspan="10">
                      <div class="mt-2 mb-4">
                        <div class="swing-container">
                          <div class="swing">
                            <div class="swing-l"></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div class="swing-r"></div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="mt-3 pagination row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="float-left">
                      <span class="text-muted pagination-counter">
                        {{ $t('pagination.entries_per_page') }}:
                      </span>
                    </div>
                    <div class="float-left">
                      <multiselect
                          v-model="perPage"
                          :options="perPageOptions"
                          track-by="value"
                          :select-label="$t('system.dropdown_select_label')"
                          :selected-label="$t('system.dropdown_selected_label')"
                          :deselect-label="$t('system.dropdown_deselect_label')"
                          label="value"
                          qid="create-org-form-organization-level"
                          @select="perPageChanged"
                          :placeholder="selectedPerPage"
                          @remove="perPageRemoved"
                      ></multiselect>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <b-pagination
                      class="float-right"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="selectedPerPage"
                      aria-controls="my-table"
                      @change="pageChanged"
                      limit="1"
                  >
                    <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
                    <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
                    <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
                    <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
                    <div slot="ellipsis-text">
                      <b-spinner small type="grow"></b-spinner>
                      <b-spinner small type="grow"></b-spinner>
                      <b-spinner small type="grow"></b-spinner>
                    </div>
                    <span class="text-muted" slot="page" slot-scope="{ page, active }">
                      <span v-if="active">{{getPerPage}}</span>
                    </span>
                  </b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ACTIVITY FILTERS -->
      <div class="col-sm-2 filter-container">
        <div class="card">
          <div class="card-body">
            <b-form-group v-if="isMember()">
              <label qid="create-a-users-label">
                {{ $t('activities.create.owners_label') }}
              </label>
              <multiselect
                  v-model="filters.owners"
                  @select="debounceInput"
                  @remove="debounceInput"
                  :options="users"
                  :multiple="true"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  :taggable="false"
                  track-by="slug"
                  :placeholder="$t('activities.create.owners_placeholder')"
                  label="name"
                  @search-change="loadUsers"
                  qid="filter-a-form-owners"
              >
                <template slot="tag" slot-scope="props">
                  <span class="mr-3 user-tag">
                    <Avatar :object="props.option" size="xs"></Avatar>
                    <span class="ml-2">{{ props.option.name }}</span>
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
              </multiselect>
            </b-form-group>

            <b-form-group>
              <label qid="create-a-tags-label">
                {{ $t('activities.create.tags_label') }}
              </label>
              <multiselect
                  v-model="filters.tags"
                  @select="debounceInput"
                  @remove="debounceInput"
                  :options="tags"
                  :multiple="true"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  :taggable="true"
                  track-by="name_translated"
                  :placeholder="$t('activities.create.tags_placeholder')"
                  label="name_translated"
                  qid="filter-a-form-tags"
                  @search-change="loadTags"
                  @tag="addTag"
              ></multiselect>
            </b-form-group>
            <hr/>
            <b-form-group>
              <label qid="create-a-organizations-label">
                {{ $t('activities.create.organizations_label') }}
              </label>
              <multiselect
                  v-model="filters.organizations"
                  @select="debounceInput"
                  @remove="debounceInput"
                  :options="organizations"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  :multiple="true"
                  :taggable="true"
                  track-by="name"
                  :placeholder="$t('activities.create.organizations_placeholder')"
                  label="name"
                  qid="filter-a-form-organizations"
                  @search-change="loadOrganizations"
              ></multiselect>
            </b-form-group>
            <b-form-group>
              <label qid="filter-a-process-group-label">
                {{ $t('processes.create.process_group_label') }}
              </label>
              <multiselect
                  v-model="filters.processGroup"
                  :options="processGroups"
                  :placeholder="$t('processes.create.process_group_placeholder')"
                  @select="debounceInput"
                  @remove="debounceInput"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  @search-change="loadProcessGroups"
                  track-by="id"
                  label="name"
                  qid="filter-p-form-process_group"
              ></multiselect>
            </b-form-group>
            <b-form-group>
              <label qid="filter-a-processing-role-label">
                {{ $t('activities.processing_role.title') }}
              </label>
              <multiselect
                  v-model="filters.processingRole"
                  :options="processingRoleOptions"
                  :placeholder="$t('activities.processing_role.pr_placeholder')"
                  @select="debounceInput"
                  @remove="debounceInput"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  track-by="name"
                  label="name"
                  qid="filter-a-form-processing-role"
              >
                <template slot="option" slot-scope="props">
                  <span v-if="props.option.value == 'Data processor'">
                    <font-awesome-icon icon="microchip" class="mr-2"/>
                  </span>
                  <span v-if="props.option.value == 'Data controller'">
                    <font-awesome-icon icon="joystick" class="mr-2"/>
                  </span>
                  <span v-if="props.option.value == 'Joint controller'">
                    <font-awesome-icon icon="handshake" class="mr-2"/>
                  </span>
                  {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
                </template>
                <template slot="singleLabel" slot-scope="props">
                  <span v-if="props.option.value == 'Data processor'">
                    <font-awesome-icon icon="microchip" class="mr-2"/>
                  </span>
                  <span v-if="props.option.value == 'Data controller'">
                    <font-awesome-icon icon="joystick" class="mr-2"/>
                  </span>
                  <span v-if="props.option.value == 'Joint controller'">
                    <font-awesome-icon icon="handshake" class="mr-2"/>
                  </span>
                  {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
                </template>
              </multiselect>
            </b-form-group>
            <hr/>
            <b-form-group>
              <label qid="create-a-users-label">
                {{ $t('activities.create.modified_by_label') }}
              </label>
              <multiselect
                  v-model="filters.modifiedBy"
                  @select="debounceInput"
                  @remove="debounceInput"
                  :options="users"
                  :multiple="false"
                  :taggable="false"
                  track-by="slug"
                  :placeholder="$t('activities.create.modified_by_placeholder')"
                  select-label="✔"
                  selected-label="✔"
                  deselect-label="x"
                  label="name"
                  @search-change="loadUsers"
                  qid="filter-a-form-modified-by"
              >
                <template slot="singleLabel" slot-scope="props">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">
                    {{ props.option.name }}
                  </span>
                </template>
              </multiselect>
            </b-form-group>

            <b-form-group>
              <label qid="filter-a-modified-from-label">
                {{ $t('activities.create.modified_by_date_from_label') }}
              </label>
              <datepicker
                  class="date-picker"
                  qid="filter-a-form-modified-from"
                  calendar-class="right"
                  @selected="debounceInput"
                  @remove="debounceInput"
                  v-model="filters.modifiedFrom"
                  :clear-button="true"
                  :placeholder="$t('activities.create.modified_by_date_from_placeholder')"
              ></datepicker>
            </b-form-group>

            <b-form-group>
              <label qid="filter-s-modified-to-label">
                {{ $t('activities.create.modified_by_date_to_label') }}
              </label>
              <datepicker
                  class="date-picker"
                  qid="filter-a-form-modified-to"
                  calendar-class="right"
                  @selected="debounceInput"
                  @remove="debounceInput"
                  :clear-button="true"
                  v-model="filters.modifiedTo"
                  :placeholder="$t('activities.create.modified_by_date_to_placeholder')"
              ></datepicker>
            </b-form-group>

            <a href="#" @click="resetFilters" class="text-right" qid="filter-s-reset">
              {{ $t('system.reset_filters') }}
            </a>
          </div>
        </div>
      </div>
    </div>


    <!-- Running projects modal -->
    <b-modal ref="running-projects" hide-footer size="xl" @hide="hideProjectsModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideProjectsModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="view-running-projects-title">
            {{ $t('projects.in_progress_title') }}
          </h5>
        </div>
      </template>

      <b-form>
        <div class="mt-3">
          <table class="table table-responsive-md table-list">
            <thead>
              <tr>
                <th scope="col">
                  {{ $t('projects.table.name') }}
                </th>
                <th scope="col">
                  {{ $t('projects.table.owners') }}
                </th>
                <th scope="col">
                  {{ $t('processes.table.tags') }}
                </th>
                <th scope="col">
                  {{ $t('projects.table.type') }}
                </th>
                <th scope="col">
                  {{ $t('projects.table.scope') }}
                </th>
                <th scope="col">
                  {{ $t('projects.create.schedule_label') }}
                </th>
                <th scope="col">
                  {{ $t('system.status') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="object in projectItems">
                <td>
                  <router-link
                      :to="{ name: 'projects.view', params: { slug: object.slug }}"
                      qid="s-view-page-link"
                  >
                    {{ object.title }}
                  </router-link>
                </td>
                <td>
                  <span class="mr-1 text-normal" v-for="user in getReducedUsers(object.users)">
                    <span qid="profile-photo">
                      <Avatar :object="user" size="xs"></Avatar>
                    </span>
                  </span>
                  <span v-if="object.users.length > 3"
                        class="badge cursor-pointer"
                        @click="openUsersModal(object)"
                  >
                    <font-awesome-icon icon="users"/>
                    + {{ object.users.length - 3 }}
                  </span>
                </td>
                <td>
                  <span v-for="tag in getReducedTags(object.tags_translated)" qid="p-tags-list">
                    <span class="badge" :title="tag.name_translated">
                      <font-awesome-icon icon="tag"/>
                      {{ tag.name_translated | truncate(35) }}
                    </span>
                  </span>
                  <span v-if="object.tags_translated.length > 3"
                        class="badge cursor-pointer"
                        @click="openTagsModal(object)"
                  >
                    <font-awesome-icon icon="tags"/>
                    + {{ object.tags_translated.length - 3 }}
                  </span>
                </td>
                <td>
                  <span v-if="object.type == 'update'" class="badge">
                    {{ $t('projects.view.update_label') }}
                  </span>
                  <span v-if="object.type == 'validation'" class="badge">
                    {{ $t('projects.view.validation_label') }}
                  </span>
                  <span v-if="object.type == 'control'" class="badge">
                    {{ $t('projects.view.control_label') }}
                  </span>
                  <span v-if="object.type == 'security_measure'" class="badge">
                    {{ $t('projects.view.security_measure_label') }}
                  </span>
                </td>
                <td>
                  <span class="badge" v-if="object.scope == 'policy'">
                    <font-awesome-icon icon="file-invoice"/>
                    {{ $t('projects.scope.policy') }}
                  </span>
                  <span class="badge" v-if="object.scope == 'system'">
                    <font-awesome-icon icon="crosshairs"/>
                    {{ $t('projects.system.label') }}
                  </span>
                  <span class="badge" v-if="object.scope == 'process'">
                    <font-awesome-icon icon="crosshairs"/>
                    {{ $t('projects.process.label') }}
                  </span>
                  <span class="badge" v-if="object.scope == 'activity'">
                    <font-awesome-icon icon="crosshairs"/>
                    {{ $t('projects.activity.label') }}
                  </span>
                  <span class="badge" v-if="object.scope == 'third_party'">
                    <font-awesome-icon icon="crosshairs"/>
                    {{ $t('projects.third_party.label') }}
                  </span>
                </td>
                <td>
                  <div class="line-height-20" v-if="object.control_type == 'continuous'">
                    <span v-if="object.control_type == 'continuous'">
                      {{ $t('projects.schedule.continuous') }}
                    </span>
                  </div>
                  <div class="text-muted line-height-20" v-if="object.control_type == 'continuous'">
                    <span v-if="object.is_active_child_project">{{ $t('system.currently_running') }}</span>
                    <span v-else-if="object.nextRun">{{ $t('projects.schedule.next_run_table_label') }}:  {{ object.nextRun | formatDate }}</span>
                    <span v-else-if="!object.nextRun">{{ $t('system.not_scheduled') }}</span>
                  </div>
                  <div :class="{'line-height-20': object.start_date}" v-if="object.control_type == 'one time'">
                    <span v-if="object.control_type == 'one time'">
                      {{ $t('projects.schedule.one_time') }}
                    </span>
                  </div>
                  <div class="text-muted line-height-20" v-if="object.start_date && object.control_type == 'one time'">
                    {{ object.start_date | formatDate }} - {{ object.end_date | formatDate }}
                  </div>
                </td>
                <td>
                  <span v-if="object.control_type == 'one time'">
                    <span v-if="object.status === 'completed'" class="pr-1">
                      <font-awesome-icon icon="check-circle" class="icon-success"/>
                      {{ $t('system.completed') }}
                    </span>
                    <span v-if="object.status === 'pending'" class="pr-1">
                      <font-awesome-icon icon="exclamation-triangle" class="risk-6"/>
                      {{ $t('system.pending') }}
                    </span>
                    <span v-if="object.status === 'in progress'" class="pr-1">
                      <font-awesome-icon icon="exclamation-triangle" class="risk-1"/>
                      {{ $t('system.in_progress') }}
                    </span>
                    <span v-if="object.status === 'closed'" class="pr-1">
                      <font-awesome-icon icon="exclamation-triangle" class="risk-12"/>
                      {{ $t('system.closed') }}
                    </span>
                  </span>
                  <span v-if="object.control_type == 'continuous'">
                    <span v-if="!object.is_active_child_project" class="pr-1">
                      <font-awesome-icon icon="exclamation-triangle" class="risk-6"/>
                      {{ $t('system.pending') }}
                    </span>
                    <span v-if="object.is_active_child_project" class="pr-1">
                      <font-awesome-icon icon="exclamation-triangle" class="risk-1"/>
                      {{ $t('system.in_progress') }}
                    </span>
                  </span>
                </td>
              </tr>

              <tr v-if="!loading && !projectItems.length" qid="no-results-row" class="text-center">
                <td colspan="10">
                  <h5 class="mt-3">
                    {{ $t('system.no_results') }}
                  </h5>
                </td>
              </tr>

              <tr v-if="loading" qid="no-results-row-rr" class="text-center">
                <td colspan="10">
                  <div class="mt-2 mb-4">
                    <div class="swing-container">
                      <div class="swing">
                        <div class="swing-l"></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div class="swing-r"></div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="proxy-footer-xl">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideProjectsModal"
                            qid="view-running-projects-cancel-button"
                  >
                    {{ $t('system.close') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>


    <!-- Download modal template -->
    <b-modal ref="download-modal" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-s-title">
          {{ $t('download_modal.title') }}
        </h4>
      </div>
      <div class="mt-2 mb-2">

        <label class="mt-2">
          {{ $t('download_modal.label.select') }}
        </label>

        <div class="row mt-2 mb-2">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.label.select_all') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="selectAll"
              :options="radioOptions"
              qid="basic-info"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.basic_info') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.basic_info"
              :options="radioOptions"
              qid="basic-info"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.owners') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.owners"
              :options="radioOptions"
              qid="owners"
            ></b-form-radio-group>
          </div>
        </div>

        <label class="mt-2">
          {{ $t('download_modal.value.activities') }}
        </label>
        <div class="row">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.activities') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.activities"
              :options="radioOptions"
              qid="activities"
            ></b-form-radio-group>
          </div>
        </div>

        <label class="mt-2" v-if="getClient.gdprModule">
          {{ $t('download_modal.value.gdpr_module') }}
        </label>

        <div class="row" v-if="getClient.gdprModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.gdpr_basic_info') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.gdpr_basic_info"
              :options="radioOptions"
              qid="gdpr_basic_info"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprAdvancedModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.legal_basis') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.legal_basis"
              :options="radioOptions"
              qid="data_subjects"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprAdvancedModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.legal_basis_validation_log') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.legal_basis_validation_log"
              :options="radioOptions"
              qid="retention_rules"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprAdvancedModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.information_obligation') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.information_obligation"
              :options="radioOptions"
              qid="data_subjects"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprAdvancedModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.information_obligation_validation_log') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.information_obligation_validation_log"
              :options="radioOptions"
              qid="retention_rule_validation_log"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprAdvancedModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.risk_profile_validation_log') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.risk_profile_validation_log"
              :options="radioOptions"
              qid="integrity_control_validation_log"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprAdvancedModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.confidentiality_validation_log') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.confidentiality_validation_log"
              :options="radioOptions"
              qid="processing_type_validation_log"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprAdvancedModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.integrity_validation_log') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.integrity_validation_log"
              :options="radioOptions"
              qid="processing_type_validation_log"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprAdvancedModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.availability_validation_log') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.availability_validation_log"
              :options="radioOptions"
              qid="processing_type_validation_log"
            ></b-form-radio-group>
          </div>
        </div>

        <label class="mt-2" v-if="getClient.riskModule">
          {{ $t('download_modal.value.risk_control_module') }}
        </label>

        <div class="row" v-if="getClient.riskModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.risk_scenarios') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.risk_scenarios"
              :options="radioOptions"
              qid="risk_scenarios"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.riskModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.risk_validation_log') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadForm.risk_validation_log"
              :options="radioOptions"
              qid="risk_validation_log"
            ></b-form-radio-group>
          </div>
        </div>

      </div>
      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="closeDownloadModal"
                  qid="delete-s-cancel-button"
        >
          {{ $t('activities.delete.cancel') }}
        </b-button>
        <b-button @click="downloadTable()"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-s-submit-button"
        >
          {{ $t('system.download') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Download modal template -->
    <b-modal ref="download-activities-modal" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-s-title">
          {{ $t('download_modal.title') }}
        </h4>
      </div>
      <div class="mt-2 mb-2">

        <label class="mt-2">
          {{ $t('download_modal.label.select') }}
        </label>

        <div class="row mt-2 mb-2">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.label.select_all') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="selectAllActivities"
              :options="radioOptions"
              qid="basic-info"
            ></b-form-radio-group>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.basic_info') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.basic_info"
              :options="radioOptions"
              qid="basic-info"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.owners') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.owners"
              :options="radioOptions"
              qid="owners"
            ></b-form-radio-group>
          </div>
        </div>

        <label class="mt-2">
          {{ $t('download_modal.value.data_mapping') }}
        </label>

        <div class="row">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.systems') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.systems"
              :options="radioOptions"
              qid="systems"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.system_data') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.system_data"
              :options="radioOptions"
              qid="system_data"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.contractBasicModule && getClient.gdprAdvancedModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.third_party_sources') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.third_party_sources"
              :options="radioOptions"
              qid="third_party_sources"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.contractBasicModule && getClient.gdprAdvancedModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.third_party_sources_data') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.third_party_sources_data"
              :options="radioOptions"
              qid="third_party_sources_data"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.contractBasicModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.third_party_receivers') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.third_party_receivers"
              :options="radioOptions"
              qid="third_party_receivers"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.contractBasicModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.third_party_receivers_data') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.third_party_receivers_data"
              :options="radioOptions"
              qid="third_party_receivers_data"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.data_flow_validation_log') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.data_flow_validation_log"
              :options="radioOptions"
              qid="data_flow_validation_log"
            ></b-form-radio-group>
          </div>
        </div>

        <label class="mt-2" v-if="getClient.gdprModule">
          {{ $t('activities.measures.title') }}
        </label>

        <div class="row" v-if="getClient.gdprModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('activities.measures.title') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.measures"
              :options="radioOptions"
              qid="measures"
            ></b-form-radio-group>
          </div>
        </div>

        <label class="mt-2" v-if="getClient.gdprModule">
          {{ $t('download_modal.value.gdpr_module') }}
        </label>

        <div class="row" v-if="getClient.gdprModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.gdpr_basic_info') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.gdpr_basic_info"
              :options="radioOptions"
              qid="gdpr_basic_info"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.data_subjects') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.data_subjects"
              :options="radioOptions"
              qid="data_subjects"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.retention_rules') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.retention_rules"
              :options="radioOptions"
              qid="retention_rules"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.retention_rule_validation_log') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.retention_rule_validation_log"
              :options="radioOptions"
              qid="retention_rule_validation_log"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.integrity_control_validation_log') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.integrity_control_validation_log"
              :options="radioOptions"
              qid="integrity_control_validation_log"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.gdprAdvancedModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.processing_type_validation_log') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.processing_type_validation_log"
              :options="radioOptions"
              qid="processing_type_validation_log"
            ></b-form-radio-group>
          </div>
        </div>

        <label class="mt-2" v-if="getClient.riskModule">
          {{ $t('download_modal.value.risk_control_module') }}
        </label>

        <div class="row" v-if="getClient.riskModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.risk_scenarios') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.risk_scenarios"
              :options="radioOptions"
              qid="risk_scenarios"
            ></b-form-radio-group>
          </div>
        </div>
        <div class="row" v-if="getClient.riskModule">
          <div class="col-sm-6">
            <p class="text-normal">
              {{ $t('download_modal.value.risk_validation_log') }}
            </p>
          </div>
          <div class="col-sm-6 text-right">
            <b-form-radio-group
              v-model="downloadActivitiesForm.risk_validation_log"
              :options="radioOptions"
              qid="risk_validation_log"
            ></b-form-radio-group>
          </div>
        </div>


      </div>
      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="closeDownloadActivitiesModal"
                  qid="delete-s-cancel-button"
        >
          {{ $t('activities.delete.cancel') }}
        </b-button>
        <b-button @click="downloadActivitiesTable()"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-s-submit-button"
        >
          {{ $t('system.download') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Process report modal -->
    <b-modal ref="process-modal" hide-footer @hide="closeProcessModal">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{$t('reports.process_overview_report')}}
        </h4>
      </div>
      <b-alert v-if="modalError.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ modalError }}
      </b-alert>

      <div class="form-container">
        <b-form-group>
          <label qid="create-ac-pg-label">
            {{$t('reports.modal.scope_type_label')}}
          </label>
          <multiselect
              v-model="selectedScopeType"
              :options="processScopeTypes"
              :placeholder="$t('reports.modal.scope_type_placeholder')"
              @select="resetObjects"
              label="name"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              track-by="value"
              qid="create-rr-form-rr"
          ></multiselect>
        </b-form-group>
        <b-form-group v-if="selectedScopeType && selectedScopeType.value && selectedScopeType.value == 'process_owner'">
          <label qid="create-p-users-label">
            {{ $t('processes.create.owners_label') }}
          </label>
          <multiselect
              v-model="selectedUsers"
              :options="users"
              :multiple="true"
              :taggable="false"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              @search-change="loadUsers"
              track-by="slug"
              :placeholder="$t('processes.create.owners_placeholder')"
              label="name"
              qid="create-p-users-select"
          >
            <template slot="tag" slot-scope="props">
              <Avatar :object="props.option" size="xs"></Avatar>
              <span class="ml-2">
                {{ props.option.name }}
              </span>
            </template>
          </multiselect>
        </b-form-group>
        <b-form-group v-if="selectedScopeType && selectedScopeType.value && selectedScopeType.value == 'process_group'">
          <label qid="create-p-pg-label">
            {{ $t('processes.create.process_group_label') }}
          </label>
          <multiselect
              v-model="selectedProcessGroups"
              :options="processGroups"
              :multiple="true"
              :taggable="false"
              @search-change="loadProcessGroups"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('processes.create.process_group_placeholder')"
              label="name"
              track-by="slug"
              qid="create-p-form-pg"
          ></multiselect>
        </b-form-group>
        <b-form-group v-if="selectedScopeType && selectedScopeType.value && selectedScopeType.value == 'process_name'">
          <label qid="create-p-pg-label">
            {{ $t('reports.modal.process_label') }}
          </label>
          <multiselect
              v-model="selectedProcesses"
              :options="processes"
              :multiple="true"
              :taggable="false"
              @search-change="loadProcesses"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('reports.modal.process_placeholder')"
              label="name"
              track-by="slug"
              qid="create-p-form-pg"
          ></multiselect>
        </b-form-group>
      </div>
      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="closeProcessModal"
                  qid="create-rr-cancel-button"
        >
          {{ $t('risk_scenarios.threat.create.cancel') }}
        </b-button>
        <b-button @click="downloadProcessOverviewFile()"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="create-rr-submit-button"
        >
          {{ $t('risk_scenarios.threat.create.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Article report modal -->
    <b-modal ref="article-modal" hide-footer @hide="closeArticleModal">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{$t('reports.article_report')}}
        </h4>
      </div>
      <b-alert v-if="modalError.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ modalError }}
      </b-alert>

      <div class="form-container">

        <b-form-group>
          <label qid="create-ac-pg-label">
            {{ $t('activities.processing_role.title') }}
          </label>
          <multiselect
              v-model="processingRoles"
              :options="processingRoleOptions"
              :multiple="true"
              :placeholder="$t('activities.processing_role.pr_placeholder')"
              label="name"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              track-by="name"
              qid="processing-role-dropdown"
          >
            <template slot="option" slot-scope="props">
              <span v-if="props.option.value == 'Data processor'">
                <font-awesome-icon icon="microchip" class="mr-2"/>
              </span>
              <span v-if="props.option.value == 'Data controller'">
                <font-awesome-icon icon="joystick" class="mr-2"/>
              </span>
              <span v-if="props.option.value == 'Joint controller'">
                <font-awesome-icon icon="handshake" class="mr-2"/>
              </span>
              {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
            </template>
            <template slot="singleLabel" slot-scope="props">
              <span v-if="props.option.value == 'Data processor'">
                <font-awesome-icon icon="microchip" class="mr-2"/>
              </span>
              <span v-if="props.option.value == 'Data controller'">
                <font-awesome-icon icon="joystick" class="mr-2"/>
              </span>
              <span v-if="props.option.value == 'Joint controller'">
                <font-awesome-icon icon="handshake" class="mr-2"/>
              </span>
              {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
            </template>
          </multiselect>
        </b-form-group>
        <b-form-group>
          <label qid="create-ac-pg-label">
            {{$t('reports.modal.scope_type_label')}}
          </label>
          <multiselect
              v-model="selectedScopeType"
              :options="processScopeTypes"
              :placeholder="$t('reports.modal.scope_type_placeholder')"
              label="name"
              @select="resetObjects"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              track-by="value"
              qid="create-rr-form-rr"
          ></multiselect>
        </b-form-group>
        <b-form-group v-if="selectedScopeType && selectedScopeType.value && selectedScopeType.value == 'process_owner'">
          <label qid="create-p-users-label">
            {{ $t('processes.create.owners_label') }}
          </label>
          <multiselect
              v-model="selectedUsers"
              :options="users"
              :multiple="true"
              :taggable="false"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              @search-change="loadUsers"
              track-by="slug"
              :placeholder="$t('processes.create.owners_placeholder')"
              label="name"
              qid="create-p-users-select"
          >
            <template slot="tag" slot-scope="props">
              <Avatar :object="props.option" size="xs"></Avatar>
              <span class="ml-2">
                {{ props.option.name }}
              </span>
            </template>
          </multiselect>
        </b-form-group>
        <b-form-group v-if="selectedScopeType && selectedScopeType.value && selectedScopeType.value == 'process_group'">
          <label qid="create-p-pg-label">
            {{ $t('processes.create.process_group_label') }}
          </label>
          <multiselect
              v-model="selectedProcessGroups"
              :options="processGroups"
              :multiple="true"
              :taggable="false"
              @search-change="loadProcessGroups"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('processes.create.process_group_placeholder')"
              label="name"
              track-by="slug"
              qid="create-p-form-pg"
          ></multiselect>
        </b-form-group>
        <b-form-group v-if="selectedScopeType && selectedScopeType.value && selectedScopeType.value == 'process_name'">
          <label qid="create-p-pg-label">
            {{ $t('reports.modal.process_label') }}
          </label>
          <multiselect
              v-model="selectedProcesses"
              :options="processes"
              :multiple="true"
              :taggable="false"
              @search-change="loadProcesses"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              :placeholder="$t('reports.modal.process_placeholder')"
              label="name"
              track-by="slug"
              qid="create-p-form-pg"
          ></multiselect>
        </b-form-group>
      </div>
      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="closeArticleModal"
                  qid="create-rr-cancel-button"
        >
          {{ $t('risk_scenarios.threat.create.cancel') }}
        </b-button>
        <b-button @click="downloadArticleFile()"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="create-rr-submit-button"
        >
          {{ $t('risk_scenarios.threat.create.submit') }}
        </b-button>
      </div>
    </b-modal>


    <ShowMoreModal
        :items="selectedItem.tags_translated"
        :show="showTagsModal"
        @closeViewModal="closeTagsModal"
        type="tags"
    ></ShowMoreModal>

    <ShowMoreModal
        :items="selectedItem.organizations"
        :show="showOrganizationsModal"
        @closeViewModal="closeOrganizationsModal"
        type="organizations"
    ></ShowMoreModal>

    <ShowMoreModal
        :items="selectedItem.countries_with_flag"
        :show="showCountriesModal"
        @closeViewModal="closeCountriesModal"
        type="countries_with_flag"
    ></ShowMoreModal>

    <ShowMoreModal
        :items="selectedItem.process_groups"
        :show="showProcessGroupsModal"
        @closeViewModal="closeProcessGroupsModal"
        type="process_groups"
    ></ShowMoreModal>

    <ShowMoreModal
        :items="selectedItem.users"
        :show="showUsersModal"
        @closeViewModal="closeUsersModal"
        type="users"
    ></ShowMoreModal>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import {config} from '@/config.js';
  import Avatar from '@/components/Avatar.vue';
  import ShowMoreModal from '@/components/ShowMoreModal.vue';
  import Datepicker from 'vuejs-datepicker';
  import permissionMap from '@/util/ACL/permissionMap';
  import permissionCheck from "@/util/ACL/permissionCheck";
  import roleCheck from '@/util/ACL/roleCheck.js';
  import GuideButton from '@/components/guide/GuideButton.vue';
  import CreateProjectModal from '@/views/Projects/CreateProjectModal.vue';
  import ProcessCreateModal from '@/views/Processes/ProcessCreateModal.vue';
  import ActivityEditForm from '@/views/Activities/ActivityEditForm.vue';
  import ProcessSideFilter from '@/components/processes/ProcessSideFilter.vue';
  import ProcessTopBar from '@/components/processes/ProcessTopBar.vue';


  export default {
    name: 'Processes',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('processes.title'),
            active: true
          }
        ],
        types: ['update','validation'],
        tableItems: [],
        projectItems: [],
        loading: false,
        activityItems: [],
        selectedProcess: {},
        currentPage: 1,
        totalRows: 0,
        itemToDelete: {},
        selectedSort: '',
        selectedDirection: '',
        filterOpened: false,
        keywordValue: '',
        filters: {
          category: {},
          processGroup: [],
          processingRole: [],
          owners: [],
          tags:[],
          modifiedBy: [],
          modifiedFrom: '',
          modifiedTo: '',
          organizations: [],
          keywordValue: ''
        },
        // filtersP: {},
        tableColumns: {
          responsibles: 0,
          tags: 0,
          organizations: 1,
          countries: 1,
          processGroup: 0,
          lastModified: 0,
        },
        articleReport: {},
        riskReport: {},
        systemReport: {},
        thirdPartyReport: {},
        processRiskReport: {},
        processOverviewReport: {},
        riskControlReport: {},
        appendixRiskReport: {},
        soaReport: {},
        appendixSoaReport: {},
        appendixImplementationReport: {},
        processGroups: [],
        typeInput: '',
        sLoading: true,
        activeProcessGroups: [],
        perPage: '',
        selectedPerPage: "10",
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' },
        ],
        tags: [],
        selectedTags: [],
        users: [],
        selectedUsers: [],
        newTags: [],
        organizations: [],
        articles: [],
        selectedArticle: [],
        selectedItem: {},
        showTagsModal: false,
        showOrganizationsModal: false,
        showCountriesModal: false,
        showProcessGroupsModal: false,
        showUsersModal: false,
        myGuides: [],
        radioOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0}
        ],
        selectAll: '',
        selectAllActivities: '',
        downloadForm: {
          availability_validation_log: 0,
          basic_info: 1,
          confidentiality_validation_log: 0,
          gdpr_basic_info: 0,
          information_obligation: 0,
          information_obligation_validation_log: 0,
          integrity_validation_log: 0,
          legal_basis: 0,
          legal_basis_validation_log: 0,
          owners: 0,
          risk_profile_validation_log: 0,
          risk_scenarios: 0,
          risk_validation_log: 0,
          activities: 0
        },
        downloadActivitiesForm: {
          basic_info: 1,
          owners: 0,
          systems: 0,
          system_data: 0,
          third_party_sources: 0,
          third_party_sources_data: 0,
          third_party_receivers: 0,
          third_party_receivers_data: 0,
          data_flow_validation_log: 0,
          gdpr_basic_info: 0,
          data_subjects: 0,
          retention_rules: 0,
          retention_rule_validation_log: 0,
          integrity_control_validation_log: 0,
          processing_type_validation_log: 0,
          risk_scenarios: 0,
          risk_validation_log: 0,
          measures: 0,
          client: {}
        },
        processes: [],
        systems: [],
        activities: [],
        frameworks: [],
        thirdParties: [],
        selectedProcesses: [],
        selectedSystems: [],
        selectedActivities: [],
        selectedThirdParties: [],
        selectedProcessGroups: [],
        selectedRiskType: [],
        selectedScopeArea: [],
        selectedFramework: [],
        selectedFrameworks: [],
        processingRoleOptions: [
          { text: this.$t('maintenance.third_parties.processing_role.data_controller'), value: 'Data controller'},
          { text: this.$t('maintenance.third_parties.processing_role.data_processor'), value: 'Data processor'},
          { text: this.$t('activities.processing_role.joint_controller_label'), value: 'Joint controller' }
        ],
        processScopeTypes: [
          { name: this.$t('reports.scope_types.process_owner'), value: 'process_owner' },
          { name: this.$t('reports.scope_types.process_name'), value: 'process_name' },
          { name: this.$t('reports.scope_types.process_group'), value: 'process_group' },
        ],
        systemScopeTypes: [
          { name: this.$t('reports.scope_types.system_owner'), value: 'system_owner' },
          { name: this.$t('reports.scope_types.system_name'), value: 'system_name' },
        ],
        activityScopeTypes: [
          { name: this.$t('reports.scope_types.activity_owner'), value: 'activity_owner' },
          { name: this.$t('reports.scope_types.activity_name'), value: 'activity_name' },
        ],
        thirdPartyScopeTypes: [
          { name: this.$t('reports.scope_types.third_party_owner'), value: 'third_party_owner' },
          { name: this.$t('reports.scope_types.third_party_name'), value: 'third_party_name' },
        ],
        riskTypes: [
          { name: this.$t('risk_scenarios.risk_type.business_risk'), value: 'business_risk' },
          { name: this.$t('risk_scenarios.risk_type.privacy_risk'), value: 'privacy_risk' },
        ],
        scopeAreas: [
          { name: this.$t('risk_scenarios.type.process'), value: 'process' },
          { name: this.$t('risk_scenarios.type.activity'), value: 'activity' },
          { name: this.$t('risk_scenarios.type.system'), value: 'system' },
          { name: this.$t('risk_scenarios.type.third_party'), value: 'third_party' }
        ],
        processingRoles: [],
        successMessage: '',
        selectedScopeType: [],
        selectedScope: [],
        options: [],
        modalError: '',

        SideFilterRenderComponent: true,
        selectedCategory: {},
        updateCategoryList: false,
      }
    },
    components: {
      Avatar,
      Datepicker,
      ShowMoreModal,
      GuideButton,
      CreateProjectModal,
      ProcessCreateModal,
      ActivityEditForm,
      ProcessSideFilter,
      ProcessTopBar,
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getFilters() {
        return this.$store.state.activeFilters
      },
      getTableColumns() {
        if (localStorage.getItem('tableColumns')) {
          return JSON.parse(localStorage.getItem('tableColumns'))
        } else {
          return {}
        }
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.filters = {
          category: {},
          processGroup: [],
          processingRole: [],
          owners: [],
          tags:[],
          modifiedBy: [],
          modifiedFrom: '',
          modifiedTo: '',
          organizations: [],
          keywordValue: ''
        }
        this.selectedCategory = {}
        this.loadContent()
        if (this.getTableColumns.activities) {
          this.tableColumns = this.getTableColumns.activities
        }
      },
      selectAll: function (value) {
        this.downloadForm.basic_info = value
        this.downloadForm.owners = value

        if (this.getClient.gdprModule) {
          this.downloadForm.legal_basis = value
          this.downloadForm.legal_basis_validation_log = value
          this.downloadForm.information_obligation = value
          this.downloadForm.information_obligation_validation_log = value
          this.downloadForm.risk_profile_validation_log = value
          this.downloadForm.confidentiality_validation_log = value
          this.downloadForm.integrity_validation_log = value
          this.downloadForm.availability_validation_log = value
          this.downloadForm.gdpr_basic_info = value
        }

        if (this.getClient.riskModule) {
          this.downloadForm.risk_scenarios = value
          this.downloadForm.risk_validation_log = value
        }

        this.downloadForm.activities = value
      },
      selectAllActivities: function (value) {
        this.downloadActivitiesForm.basic_info = value
        this.downloadActivitiesForm.owners = value
        this.downloadActivitiesForm.systems = value
        this.downloadActivitiesForm.system_data = value

        if (this.getClient.contractBasicModule) {
          this.downloadActivitiesForm.third_party_sources = value
          this.downloadActivitiesForm.third_party_sources_data = value
          this.downloadActivitiesForm.third_party_receivers = value
          this.downloadActivitiesForm.third_party_receivers_data = value
        }

        this.downloadActivitiesForm.data_flow_validation_log = value

        if (this.getClient.gdprModule) {
          this.downloadActivitiesForm.gdpr_basic_info = value
          this.downloadActivitiesForm.data_subjects = value
          this.downloadActivitiesForm.retention_rules = value
          this.downloadActivitiesForm.retention_rule_validation_log = value
          this.downloadActivitiesForm.integrity_control_validation_log = value
          this.downloadActivitiesForm.processing_type_validation_log = value
        }

        if (this.getClient.riskModule) {
          this.downloadActivitiesForm.risk_scenarios = value
          this.downloadActivitiesForm.risk_validation_log = value
        }

        this.downloadActivitiesForm.measures = value
      }
    },
    methods: {
      debounceInput: _.debounce(function() {
        if (this.filters.keywordValue == '' || this.filters.keywordValue.length > 2)
        this.loadContent()
      }, 600),
      updateSelectedFilter(item) {
        if (!item) {
          this.filters.category = {}
          this.selectedFilterName = ''
        }else{
          this.filters.category = item
          this.selectedFilterName = item.name
        }

        this.selectedCategory = this.filters.category;
        this.debounceInput()
      },
      forceSideFilterRenderComponent(object) {
        // store selected category provided from the top bar component
        this.selectedCategory = object
        this.filters.category = this.selectedCategory
        this.updateCategoryList = true
      },
      forceListUpdate(object) {
        this.selectedCategory = object
        this.filters.category = this.selectedCategory
        this.updateCategoryList = true
        this.loadContent()
      },

      goToHome() {
        this.$router.push('/')
      },
      resetObjects() {
        this.selectedProcesses = [],
        this.selectedProcessGroups = []
        this.selectedUsers = []
        this.selectedSystems = []
        this.selectedThirdParties = []
      },
      getLoadingMessage() {
        let self = this;
      },
      openArticleModal() {
        this.selectedScopeType = []
        this.selectedProcesses = []
        this.selectedProcessGroups = []
        this.selectedUsers = []
        this.loadProcessGroups();
        this.loadProcesses();
        this.loadUsers();
        this.$refs['article-modal'].show()
      },
      closeArticleModal() {
        this.modalError = ''
        this.$refs['article-modal'].hide()
      },
      openProcessModal() {
        this.selectedScopeType = []
        this.selectedProcesses = []
        this.selectedProcessGroups = []
        this.selectedUsers = []
        this.loadProcessGroups();
        this.loadProcesses();
        this.loadUsers();
        this.$refs['process-modal'].show()
      },
      closeProcessModal() {
        this.modalError = ''
        this.$refs['process-modal'].hide()
      },
      downloadArticleFile(){
        this.successMessage = ''
        let self = this;
        this.getLoadingMessage();
        let usersArray = []
        let processesArray = []
        let processGroupsArray = []
        let processingRolesArray = []

        if (this.selectedUsers && this.selectedUsers.length) {
            for (var i = 0; i < this.selectedUsers.length; i++) {
              usersArray.push(this.selectedUsers[i].id);
            }
        }
        if (this.selectedProcesses && this.selectedProcesses.length) {
          for (var i = 0; i < this.selectedProcesses.length; i++) {
            processesArray.push(this.selectedProcesses[i].id);
          }
        }
        if (this.selectedProcessGroups && this.selectedProcessGroups.length) {
          for (var i = 0; i < this.selectedProcessGroups.length; i++) {
            processGroupsArray.push(this.selectedProcessGroups[i].id);
          }
        }

        if (this.processingRoles && this.processingRoles.length) {
          for (var i = 0; i < this.processingRoles.length; i++) {
            processingRolesArray.push(this.processingRoles[i].value);
          }
        }

        if (
          ((this.selectedScopeType && this.selectedScopeType.value == 'process_owner' && this.selectedUsers && this.selectedUsers.length) ||
          (this.selectedScopeType && this.selectedScopeType.value == 'process_name' && this.selectedProcesses && this.selectedProcesses.length) ||
          (this.selectedScopeType && this.selectedScopeType.value == 'process_group' && this.selectedProcessGroups && this.selectedProcessGroups.length)) || (this.selectedScopeType && !this.selectedScopeType.value) || this.selectedScopeType == null
        ) {
          piincHttp.get('processes/generate-reports', { params:
            {
              users: usersArray,
              processes: processesArray,
              process_groups: processGroupsArray,
              client: this.getClient.slug,
              processing_roles: processingRolesArray
            }
          }).then(function(response) {
            self.disablePage = false;
            self.resetLoadingMessage();
            if (response.status == 200) {
              self.successMessage = self.$t('reports.success_message');
              self.$toastr('success', self.successMessage)
            }
            self.$refs['article-modal'].hide()
          }, function(error) {
            self.modalError = self.$t('reports.something_went_wrong');
            self.disablePage = false;
            self.resetLoadingMessage();
          });

        } else {
          if (this.selectedScopeType && this.selectedScopeType.value == 'process_owner' && this.selectedUsers && !this.selectedUsers.length) {
            self.modalError = self.$t('reports.owners_required');
          }
          if (this.selectedScopeType && this.selectedScopeType.value == 'process_name' && this.selectedProcesses && !this.selectedProcesses.length) {
            self.modalError = self.$t('reports.process_required');
          }
          if (this.selectedScopeType && this.selectedScopeType.value == 'process_group' && this.selectedProcessGroups && !this.selectedProcessGroups.length) {
            self.modalError = self.$t('reports.process_group_required');
          }
        }

      },
      downloadProcessOverviewFile(){
        this.successMessage = ''
        let self = this;
        this.getLoadingMessage();
        let usersArray = []
        let processesArray = []
        let processGroupsArray = []

        if (this.selectedUsers && this.selectedUsers.length) {
          for (var i = 0; i < this.selectedUsers.length; i++) {
            usersArray.push(this.selectedUsers[i].id);
          }
        }
        if (this.selectedProcesses && this.selectedProcesses.length) {
          for (var i = 0; i < this.selectedProcesses.length; i++) {
            processesArray.push(this.selectedProcesses[i].id);
          }
        }
        if (this.selectedProcessGroups && this.selectedProcessGroups.length) {
          for (var i = 0; i < this.selectedProcessGroups.length; i++) {
            processGroupsArray.push(this.selectedProcessGroups[i].id);
          }
        }

        if (
          ((this.selectedScopeType && this.selectedScopeType.value == 'process_owner' && this.selectedUsers && this.selectedUsers.length) ||
          (this.selectedScopeType && this.selectedScopeType.value == 'process_name' && this.selectedProcesses && this.selectedProcesses.length) ||
          (this.selectedScopeType && this.selectedScopeType.value == 'process_group' && this.selectedProcessGroups && this.selectedProcessGroups.length)) || (this.selectedScopeType && !this.selectedScopeType.value) || this.selectedScopeType == null
        ) {
          piincHttp.get('processes/generate-reports/overview', { params:
            {
              users: usersArray,
              processes: processesArray,
              process_groups: processGroupsArray,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.disablePage = false;
            self.resetLoadingMessage();
            if (response.status == 200) {
              self.successMessage = self.$t('reports.success_message');
              self.$toastr('success', self.successMessage)
            }
            self.$refs['process-modal'].hide()
          }, function(error) {
            self.modalError = self.$t('reports.something_went_wrong');
            self.disablePage = false;
            self.resetLoadingMessage();
          });

        } else {
          if (this.selectedScopeType && this.selectedScopeType.value == 'process_owner' && this.selectedUsers && !this.selectedUsers.length) {
            self.modalError = self.$t('reports.owners_required');
          }
          if (this.selectedScopeType && this.selectedScopeType.value == 'process_name' && this.selectedProcesses && !this.selectedProcesses.length) {
            self.modalError = self.$t('reports.process_required');
          }
          if (this.selectedScopeType && this.selectedScopeType.value == 'process_group' && this.selectedProcessGroups && !this.selectedProcessGroups.length) {
            self.modalError = self.$t('reports.process_group_required');
          }
        }
      },
      resetLoadingMessage() {
        this.loadingMessage = ''
      },
      /* loadUsers(query) {
        let self = this;
        piincHttp.get('users', { params:
          {
            client: this.getClient.id,
            keyword: query ? query : undefined,
            per_page: 50
          }
        }).then(function(response) {
          self.users = response.data.items
          if (self.users && !self.users.length && !query) {
            self.users.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },*/

      getReducedTags(tags) {
        let reducedTags = []
        if (tags.length > 3) {
          reducedTags = _.cloneDeep(tags);
          reducedTags = reducedTags.slice(0, 3);
        } else {
          reducedTags = tags;
        }
        return reducedTags;
      },
      getReducedOrganizations(organizations) {
        let reducedOrganizations = []
        if (organizations.length > 1) {
          reducedOrganizations = _.cloneDeep(organizations);
          reducedOrganizations = reducedOrganizations.slice(0, 1);
        } else {
          reducedOrganizations = organizations;
        }
        return reducedOrganizations;
      },
      getReducedCountries(countries) {
        let reducedCountries = []
        if (countries.length > 1) {
          reducedCountries = _.cloneDeep(countries);
          reducedCountries = reducedCountries.slice(0, 1);
        } else {
          reducedCountries = countries;
        }
        return reducedCountries;
      },
      getReducedProcessGroups(processGroups) {
        let reducedProcessGroups = []
        if (processGroups.length > 1) {
          reducedProcessGroups = _.cloneDeep(processGroups);
          reducedProcessGroups = reducedProcessGroups.slice(0, 1);
        } else {
          reducedProcessGroups = processGroups;
        }
        return reducedProcessGroups;
      },
      getReducedUsers(users) {
        let reducedUsers = []
        if (users.length > 3) {
          reducedUsers = _.cloneDeep(users);
          reducedUsers = reducedUsers.slice(0, 3);
        } else {
          reducedUsers = users;
        }
        return reducedUsers;
      },
      reloadProcesses() {
        this.updateCategoryList = true
      },
      loadProcesses(query) {
        let self = this;
        piincHttp.get('processes', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.processes = response.data.items
          self.updateCategoryList = true
          if (self.processes && !self.processes.length && !query) {
            self.processes.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      /* loadProcessGroups(query) {
        let self = this;
        piincHttp.get('process-groups', { params:
          {
            client: this.getClient.slug,
            per_page: 100,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.processGroups = response.data.items
          if (self.processGroups && !self.processGroups.length && !query) {
            self.processGroups.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      }, */
      resetFilters() {
        this.filters.process_group = '';
        this.filters.owners = [];
        this.filters.tags = [];
        this.filters.modifiedBy = [];
        this.filters.modifiedFrom = '';
        this.filters.modifiedTo = '';
        this.filters.legalBasis= [];
        this.debounceInput()
      },
      handleFilterButton(forceOpened) {
        if (!this.filterOpened) {
          this.loadProcessGroups()
          this.loadOrganizations()
          this.loadActiveProcessGroups()
          this.loadUsers()
          this.loadTags()
          this.loadArticles()
        }
        if (forceOpened) {
          this.filterOpened = true
        } else {
          this.filterOpened = !this.filterOpened
        }
      },
      handleDownloadModal() {
        this.$refs['download-modal'].show()
      },
      closeDownloadModal() {
        this.$refs['download-modal'].hide()
      },
      showProjectsModal() {
        this.loadProjects()
        this.$refs['running-projects'].show()
      },
      hideProjectsModal() {
        this.$refs['running-projects'].hide()
      },
      downloadTable() {
        let self = this;
        this.downloadForm.client = this.getClient.slug;
        piincHttp.post('processes/download', this.downloadForm).then(function() {
          self.closeDownloadModal();
          self.$toastr('success', self.$t('exports.success_message'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      handleDownloadActivitiesModal() {
        this.$refs['download-activities-modal'].show()
      },
      closeDownloadActivitiesModal() {
        this.$refs['download-activities-modal'].hide()
      },
      downloadActivitiesTable() {
        let self = this;
        this.downloadActivitiesForm.client = this.getClient.slug;
        piincHttp.post('activities/download', this.downloadActivitiesForm).then(function() {
          self.closeDownloadActivitiesModal();
          self.$toastr('success', self.$t('exports.success_message'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      openTagsModal(object) {
        this.selectedItem = object
        this.showTagsModal = true
      },
      closeTagsModal() {
        this.selectedItem = {}
        this.showTagsModal = false
      },
      openOrganizationsModal(object) {
        this.selectedItem = object
        this.showOrganizationsModal = true
      },
      closeOrganizationsModal() {
        this.selectedItem = {}
        this.showOrganizationsModal = false
      },
      openCountriesModal(object) {
        this.selectedItem = object
        this.showCountriesModal = true
      },
      closeCountriesModal() {
        this.selectedItem = {}
        this.showCountriesModal = false
      },
      openProcessGroupsModal(object) {
        this.selectedItem = object
        this.showProcessGroupsModal = true
      },
      closeProcessGroupsModal() {
        this.selectedItem = {}
        this.showProcessGroupsModal = false
      },
      openUsersModal(object) {
        this.selectedItem = object
        this.showUsersModal = true
      },
      closeUsersModal() {
        this.selectedItem = {}
        this.showUsersModal = false
      },
      getReducedTags(tags) {
        let reducedTags = []
        if (tags.length > 3) {
          reducedTags = _.cloneDeep(tags);
          reducedTags = reducedTags.slice(0, 3);
        } else {
          reducedTags = tags;
        }
        return reducedTags;
      },
      getReducedUsers(users) {
        let reducedUsers = []
        if (users.length > 3) {
          reducedUsers = _.cloneDeep(users);
          reducedUsers = reducedUsers.slice(0, 3);
        } else {
          reducedUsers = users;
        }
        return reducedUsers;
      },
      isMember() {
        if (this.getClient && this.getClient.user_roles && this.getClient.user_roles.length == 1 && this.getClient.user_roles[0].name == 'Member') {
          return false;
        } else {
          return true;
        }
      },
      addTag(newTag) {
        const tag = {
          name: newTag,
          translatable: newTag,
          name_translated: newTag
        }
        this.selectedTags.push(tag)
        this.newTags.push(tag)
      },
      selectFilterGroup(group){
        this.handleFilterButton();
        this.filters.process_group = group;
        this.debounceInput();
        this.filterOpened = 1;
      },
      selectSort(sort) {
        // If old and new sort are same, switch just direction
        if (sort === this.selectedSort) {
          this.selectedDirection = this.selectedDirection === 'desc' ? 'asc' : 'desc';
        } else {
          // If different sort, set sort and set direction to default
          this.selectedDirection = 'desc'
          this.selectedSort = sort;
        }
        this.loadContent();
      },
      handleTypeInput(input) {
        this.typeInput = input;
      },
      downloadMedia(object){
        piincHttp.get('clients/' + this.getClient.slug + '/report/' + object.collection_name, {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          if (navigator && navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(new Blob([response.data]), object.file_name);
          } else {
            const link = document.createElement('a');
            link.href = url;
            link.download = object.file_name;

            link.click();
            link.remove()
            window.URL.revokeObjectURL(url);
          }
        }, function() {});
      },
      loadProjects() {
        this.loading = true;
        let self = this;
        piincHttp.get('projects', { params:
          {
            per_page: 50,
            sort: this.selectedSort !== '' ? this.selectedSort : undefined,
            order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
            status: ['in progress', 'pending'],
            scopes: ['process', 'activity'],
            without_parent: 1,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.loading = false;
          self.projectItems = response.data.items;
        }, function() {});
      },
      loadContent(page, perPage) {
        if (this.getStorePerPage) {
          this.selectedPerPage = this.getStorePerPage;
        }

        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.selectedPerPage;
        let self = this;
        let formOwners = [];
        let formTags = [];
        let formOrganizations = [];

        this.tableItems = [];
        this.sLoading = true;

        // Append list of users to FormData
        if (this.filters.owners && this.filters.owners.length) {
          for (var i = 0; i < this.filters.owners.length; i++) {
            formOwners[i] = this.filters.owners[i].id;
          }
          this.handleFilterButton(true)
        }

        if (this.filters.tags && this.filters.tags.length) {
          for (var t = 0; t < this.filters.tags.length; t++) {
            formTags[t] = this.filters.tags[t].id;
          }
          this.handleFilterButton(true)
        }

        if (this.filters.organizations && this.filters.organizations.length) {
          for (var t = 0; t < this.filters.organizations.length; t++) {
            formOrganizations[t] = this.filters.organizations[t].id;
          }
          this.handleFilterButton(true)
        }

        if (
          (this.filters.modifiedBy && this.filters.modifiedBy.id) ||
          (this.filters.process_group && this.filters.process_group.id) ||
          this.filters.modifiedFrom ||
          this.filters.modifiedTo
        ) {
          this.handleFilterButton(true)
        }

        //if (!this.filters.category.slug) {
          piincHttp.get('activities', { params:
            {
              page: pageNumber,
              per_page: perPageNumber,
              sort: this.selectedSort !== '' ? this.selectedSort : undefined,
              order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
              owners: formOwners ? formOwners : undefined,
              tags: formTags ? formTags : undefined,
              organizations: formOrganizations ? formOrganizations : undefined,
              processing_role: this.filters.processingRole ? this.filters.processingRole.value : undefined,
              process_group: this.filters.processGroup ? this.filters.processGroup.id : undefined,
              process: this.filters.category.id ? this.filters.category.id : undefined,
              modified_by: this.filters.modifiedBy ? this.filters.modifiedBy.id : undefined,
              modified_from: this.filters.modifiedFrom ? this.filters.modifiedFrom : undefined,
              modified_to: this.filters.modifiedTo ? this.filters.modifiedTo : undefined,
              keyword: this.filters.keywordValue !== '' ? this.filters.keywordValue : undefined,
              client: this.getClient.slug,
            }
          }).then(function(response) {
            self.sLoading = false;
            self.tableItems = response.data.items;
            // Set number of total items
            self.totalRows = response.data.total_count;
          }, function() {});

        // }else{
        //
        //   piincHttp.get('processes/' + this.filters.category.slug + '/activities', { params:
        //     {
        //       page: 1,
        //       per_page: perPageNumber,
        //       sort: this.selectedSort !== '' ? this.selectedSort : undefined,
        //       order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
        //       owners: formOwners ? formOwners : undefined,
        //       tags: formTags ? formTags : undefined,
        //       organizations: formOrganizations ? formOrganizations : undefined,
        //       processing_role: this.filters.processingRole ? this.filters.processingRole.value : undefined,
        //       process_group: this.filters.processGroup ? this.filters.processGroup.id : undefined,
        //       modified_by: this.filters.modifiedBy ? this.filters.modifiedBy.id : undefined,
        //       modified_from: this.filters.modifiedFrom ? this.filters.modifiedFrom : undefined,
        //       modified_to: this.filters.modifiedTo ? this.filters.modifiedTo : undefined,
        //       keyword: this.filters.keywordValue !== '' ? this.filters.keywordValue : undefined,
        //     }
        //   }).then(function(response) {
        //     self.sLoading = false;
        //     self.tableItems = response.data
        //     // Set number of total items
        //     self.totalRows = response.data.length;
        //   }, function() {});
        // }
      },
      pageChanged(page) {
        // Load Third parties when page changed listener is triggered
        this.loadContent(page)
      },
      perPageChanged(perPage) {
        let self = this;
        // Load Third parties when page changed listener is triggered
        this.loadContent(1, perPage.value)
        self.selectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.selectedPerPage);
      },
      perPageRemoved() {
        let self = this;
        // Load Third parties when page changed listener is triggered
        self.selectedPerPage = self.perPageOptions[0].value
        this.loadContent(1, self.selectedPerPage)

      },
      loadOrganizations(query) {
        let self = this;
        piincHttp.get('organizations', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.organizations = response.data.items
          if (self.organizations && !self.organizations.length && !query) {
            self.organizations.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      loadProcessGroups() {
        let self = this;
        piincHttp.get('process-groups', { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.processGroups = response.data.items
        }, function() {});
      },
      loadActiveProcessGroups() {
        let self = this;
        piincHttp.get('processes/groups', { params:
            {
              client: this.getClient.slug
            }
        }).then(function(response) {
          self.activeProcessGroups = response.data
          if (self.activeProcessGroups && !self.activeProcessGroups.length) {
            self.activeProcessGroups.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      loadUsers(query) {
        let self = this;
        piincHttp.get('users', { params:
          {
            client: this.getClient.id,
            keyword: query ? query : undefined,
            per_page: 10
          }
        }).then(function(response) {
          self.users = response.data.items
          if (self.users && !self.users.length && !query) {
            self.users.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      loadTags(query) {
        let self = this;
        piincHttp.get('tags', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.tags = response.data
          for (var i = 0; i < self.newTags.length; i++) {
            self.tags.push(self.newTags[i]);
          }
          if (self.tags && !self.tags.length && !query) {
            self.tags.push({name_translated: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      loadArticles(query) {
        let self = this;
        piincHttp.get('articles', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.articles = response.data.items
          if (self.articles && !self.articles.length && !query) {
            self.articles.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      permissionMap() {
        return permissionMap;
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Process' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Process',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      }
    },
    beforeRouteLeave(to, from, next) {
      // let objectP;
      // if (!this.selectedCategory.slug) {
      //   objectP = {
      //     type: 'processes',
      //     filters: ''
      //   }
      // } else {
      //   objectP = {
      //     type: 'processes',
      //     filters: this.selectedCategory.slug
      //   }
      // }

      let objectA = {
        type: 'activities',
        filters: this.filters
      }

      let columnsObject = {
        type: 'activities',
        tableColumns: this.tableColumns
      }

      // this.$store.commit('storeActiveFilters', objectP);
      this.$store.commit('storeActiveFilters', objectA);
      this.$store.commit('storeTableColumns', columnsObject);
      this.$store.commit('storePerPage', this.selectedPerPage);
      next()
    },
    created () {
      if (this.getClient && this.getClient.slug) {
        if (this.getFilters.activities) {
          this.filters = this.getFilters.activities
        }

        if (!this.filters.category.slug) {
          this.selectedCategory = {}
        }else{
          this.selectedCategory = this.filters.category
        }

        if (this.getTableColumns.activities) {
          this.tableColumns = this.getTableColumns.activities
        }

        this.loadContent()
      }

      this.loadGuides('process_list_page');
    }
  }
</script>
